import { DynamicLoader } from "@mcleod/core";
import { MainPage } from "@mcleod/common";
import { Layout, Panel } from "@mcleod/components";
import { AppPageHeader } from "../pageheader/AppPageHeader";
import { AppRouter } from "../router/AppRouter";
import { AppPageFooter } from "../pagefooter/AppPageFooter";
import { AppMainPageProps } from "./AppMainPageProps";

export class AppMainPage extends MainPage implements AppMainPageProps {
    private _shouldHideFooter: boolean;

    constructor(props: Partial<AppMainPageProps>) {
        super(props);
        DynamicLoader.mapPathsToClasses("mobile-components", require['context']("@mcleod/mobile-components/src", true));
    }

    public override get pageHeader(): AppPageHeader {
        return AppPageHeader.instance;
    }

    public override get router(): AppRouter {
        return AppRouter.instance;
    }

    public get footer(): AppPageFooter {
        return AppPageFooter.instance;
    }

    public override evaluateExternalLinkVisibility(topMostPanel: Panel, currentLayouts: Layout[]) {
        // TODO I envision help link button living on the AppPageFooter object, once we have an fleshed out implementation.
    }

    public get shouldHideFooter(): boolean {
        return this._shouldHideFooter ?? true;
    }

    public set shouldHideFooter(value: boolean) {
        this._shouldHideFooter = value;
    }

    public static get instance(): AppMainPage {
        return MainPage.instance as AppMainPage;
    }
}
